/* eslint-disable @typescript-eslint/no-explicit-any */
import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';
import { IEveryDoggyAPIServices } from '../../../../../../../../utils/services/EveryDoggyAPIServices';
import OneLinkParametersHelper from '../../../../../../../../utils/services/OneLinkParametersComposer';
import { IAppleGoogleViewModel } from './types';
import {analyticsEventsTracker, EVENT_TRACKERS, GTMQuizFunnelEvent } from '../../../../../../../../utils/analytics';
import { StripePurchaseDigitalProductRequest } from '../../../../../../../../utils/services/EveryDoggyAPITypes';
import { getInternalPDFId } from '../../../../../../../../utils/scripts/getInternalPDFId';
import getAmplitudeDeviceId from '../../../../../../../../utils/scripts/amplitudeDeviceId';

const ComposeAppleGoogleViewModel = (
	sourceURL: string,
	apiServices: IEveryDoggyAPIServices,
	errorLogger: IErrorLoggerWithUserSupport,
): IAppleGoogleViewModel => {

	const oneLinkParametersHelper = OneLinkParametersHelper;

	const getStripeKey = async () => {
		let data = await apiServices.getStripeConfig();
		if (!data) data = await apiServices.getStripeConfig();
		if (!data?.publishableKey) {
			throw new Error('Stripe config unavailable');
		}
		return data.publishableKey;
	};

	const processPaymentAction = (
		paymentMethodId: string,
		productId: number,
		email: string,
		productName?: string,
		paymentSystem?: string,
	) => {
    
		const dataToSend: StripePurchaseDigitalProductRequest = {
			amplitude_device_id: getAmplitudeDeviceId(),
			email: email,
      payment_method_id: paymentMethodId,
      digital_product_offer_id: productId,
			fbclickid: oneLinkParametersHelper.getFBclickId(sourceURL),
      fbp: oneLinkParametersHelper.getFBp(sourceURL),
      source_url: sourceURL,
			internal_id: getInternalPDFId(productId),
		};

		return apiServices.purchaseStripeDigitalProduct(dataToSend, paymentSystem, productName)
			.then(result => {
				if(result) {
					return {};
				};
			});
	};

	const processPaymentCancel = async () => {
		errorLogger.logMessage('stripe payment cancelled');
	};

	const processPaymentError = async (error: any) => {
		errorLogger.logError({
			name: 'Stripe error',
			message: JSON.stringify(error)
		});
	};

	return {
		getStripeKey,
		processPaymentCancel,
		processPaymentError,
		processPaymentAction,
	};
};

export default ComposeAppleGoogleViewModel;